module.exports = __webpack_public_path__ + "static/img/OM4.0e01718f.png";